<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: Assets.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,   -->
<!-- propagated, or distributed without prior approval by ESA.               -->
<template>
  <div class="row">
    <!-- <button class="test-button" @click="testButton">TEST</button> -->
    <div v-show="showSidebar" class="assets__sidebar col-md-2">
      <div class="filter-title d-flex justify-content-between">
        <div class="filter-name">
          <i class="icon icon-filter text-primary"></i>
          <span class="title-text"> <i class="filter-icon"></i>Filters </span>
        </div>
        <span class="close-button">
          <button
            title="Hide"
            type="button"
            class="toggle-sidebar-inside-button btn-reset"
            @click.prevent="toggleSidebar"
          >
            <span class="icon-chevron-wrapper-open">
              <i class="icon icon-chevron-left text-primary font-14" :style="styleToggleSidebar"></i>
            </span>
          </button>
        </span>
      </div>
      <asset-filter
        :filters="filters"
        :value="search.filters"
        @input="changeFilters"
        @showMaxNumberOfFiltersModal="showMaxNumberOfFiltersModal"
        :numberOfSelectedFilters="search.filters.length"
      />
      <!-- v-model could work but does not allow to do a different thing in the event of change, which we need to do in order to reset the page to 1 -->
      <!-- v-model="search.filters"  -->
    </div>
    <div :class="clsContent">
      <!-- Search and menu -->
      <form class="assets__search" @submit.prevent="applyNewSearch" autocomplete="off">
        <div class="form-row">
          <!-- Toggle sidebar + date filter -->
          <div class="assets__search-dates form-group">
            <div class="input-group">
              <!-- Toggle sidebar -->
              <button
                title="Show"
                type="button"
                class="toggle-sidebar-outside-button btn-reset theme-shadow mr-2"
                :class="clsToggleSidebarButton"
                @click.prevent="toggleSidebar"
              >
                <i class="icon icon-filter text-primary" :style="styleToggleSidebar"></i>
                <span class="icon-chevron-wrapper-closed">
                  <i class="icon icon-chevron-left text-primary font-14" :style="styleToggleSidebar"></i>
                </span>
              </button>
              <!-- Date from -->
              <div
                title="Filter by Date"
                role="button"
                class="date-pickers d-flex theme-shadow"
                :class="showPicker ? 'bg-primary text-white' : 'bg-white text-primary'"
                ref="datePicker"
              >
                <date-range-picker
                  :dateFrom="dateFrom"
                  :dateTo="dateTo"
                  @dateRangeChanged="onDateRangeChanged"
                  @dayOfYearSelected="onDayOfYearSelected"
                  @GPSWeekSelected="onGPSWeekSelected"
                  @showPicker="showPicker = true"
                  @hidePicker="showPicker = false"
                />
                <!-- <flat-pickr
                  class="assets__date-from form-control"
                  placeholder="From"
                  :config="datepickerConfig"
                  v-model="dateFrom"
                ></flat-pickr>
                <flat-pickr
                  class="assets__date-to form-control"
                  placeholder="To"
                  :config="datepickerConfig"
                  v-model="dateTo"
                ></flat-pickr>-->
              </div>
            </div>
          </div>
          <!-- Location search (when map is visible) -->
          <!-- <div
            v-if="showMap"
            class="assets__search-coord form-group flex-grow-1 d-flex"
          >
            <div class="input-group w-auto">
              <button
                type="button"
                class="assets__toggle-map btn-reset"
                @click.prevent="toggleMap"
              >
                <i class="icon icon-earth text-primary">
                </i>
              </button>
            </div>
            <div class="input-group">
              <input
                class="assets__lat1 form-control theme-shadow"
                type="text"
                placeholder="Lat1"
                v-model="lat1"
                @change="coordsInputted"
              />
              <input
                class="assets__lng1 form-control theme-shadow"
                type="text"
                placeholder="Long1"
                v-model="lng1"
                @change="coordsInputted"
              />
              <input
                class="assets__lat2 form-control theme-shadow"
                type="text"
                placeholder="Lat2"
                v-model="lat2"
                @change="coordsInputted"
              />
              <input
                class="assets__lng2 form-control theme-shadow"
                type="text"
                placeholder="Long2"
                v-model="lng2"
                @change="coordsInputted"
              />
              <div class="input-group-append">
                <button class="assets__search-submit btn btn-sm" type="submit">
                  <i
                    class="icon icon-search text-primary"
                    title="icon view"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </div>
          </div>-->

          <!-- Search bar (keyword search when map is hidden) -->
          <div class="assets__search-search form-group flex-grow-1 d-flex">
            <div class="input-group w-auto">
              <!-- Toggle show map -->
              <button
                :title="showMap ? 'Hide Map' : 'Show Map'"
                type="button"
                class="assets__toggle-map btn-reset"
                :class="showMap ? 'bg-primary' : 'bg-white'"
                @click.prevent="toggleMap"
              >
                <i class="icon icon-earth" :class="showMap ? 'text-white' : 'text-primary'" aria-hidden="true">
                  <!-- {{ showMap ? "font_download" : "language" }} -->
                </i>
              </button>
            </div>
            <div class="input-group">
              <!-- <input
                id="input-field"
                class="assets__search-box form-control theme-shadow"
                type="search"
                name="search"
                placeholder="Search GNSS Assets"
                v-model="keyword"
              />-->
              <vue-autosuggest
                v-model="keyword"
                ref="autosuggestRef"
                class="assets__search-box form-control theme-shadow"
                :suggestions="[{ data: autocomplete }]"
                :input-props="inputProps"
                @input="searchAutoInputChange"
                @selected="searchAutoSelected"
                @click="searchAutoClick"
                @item-changed="searchAutoItemChanged"
              >
                <template slot-scope="{ suggestion }">
                  <span class="my-suggestion-item" :class="clsSearchAutoIsKeyword(suggestion.item)">{{
                    suggestion.item
                  }}</span>
                </template>
              </vue-autosuggest>
              <!-- MUST BE type="button" in order not to SUBMIT -->
              <!-- type="button" solved the problem field being cleared on ENTER key -->
              <div class="input-group-append">
                <!-- <button
                  type="button"
                  class="assets__search-clear btn btn-sm btn-outline-primary theme-shadow"
                  @click.prevent="clearSearch"
                >
                  <i
                    class="icon icon-close font-18"
                    title="icon view"
                    aria-hidden="true"
                  ></i>
                </button>-->
                <button title="Search" class="assets__search-submit btn btn-sm" type="submit" :disabled="!auth">
                  <i class="icon icon-search text-light" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- Location search (when map is visible) -->
      <div v-if="showMap" class="assets__search-coord form-group flex-grow-1 d-flex" :class="clsCoords">
        <div class="input-group theme-shadow">
          <input
            ref="lat1Ref"
            class="assets__lat1 form-control shadow-none"
            type="text"
            placeholder="Lat1"
            v-model="lat1"
            @keyup="coordsInputted"
          />
          <input
            class="assets__lng1 form-control shadow-none"
            type="text"
            placeholder="Long1"
            v-model="lng1"
            @keyup="coordsInputted"
          />
          <input
            class="assets__lat2 form-control shadow-none"
            type="text"
            placeholder="Lat2"
            v-model="lat2"
            @keyup="coordsInputted"
          />
          <input
            class="assets__lng2 form-control shadow-none"
            type="text"
            placeholder="Long2"
            v-model="lng2"
            @keyup="coordsInputted"
          />
          <!-- MUST BE type="button" in order not to SUBMIT -->
          <!-- type="button" solved the problem field being cleared on ENTER key -->
          <div class="input-group-append">
            <button @click="applyCoords" class="assets__search-submit btn btn-sm btn-primary">
              Apply
            </button>
          </div>
        </div>
      </div>

      <!-- Map of assets -->
      <asset-map
        ref="assetMapRef"
        v-show="showMap"
        :userCoords="coords"
        :render="reRender"
        :availableStations="availableStations"
        :validStations="validStations"
        :networks="networks"
        v-model="selectedStations"
        :applyCoords="toggleToApplyCoords"
        @mapStations="updateMapStations"
        :numberOfSelectedFilters="search.filters.length"
        @showMaxNumberOfFiltersModal="showMaxNumberOfFiltersModal"
        :wpData="wpData"
      />

      <!-- Results count and filters  -->
      <div class="assets__search-result-count col-12">
        <!-- <span>Found {{ pager.total_count }} results</span> -->
        <span>
          {{ pager.total_count ? pager.from.toLocaleString('en-US') : 0 }} - {{ pager.to.toLocaleString('en-US') }} of
          {{ pager.total_count.toLocaleString('en-US') }}
        </span>
        <span
          v-if="
            search.filters.length ||
              $route.query.query ||
              this.$route.query.date_range ||
              (this.$route.query.coord && this.$route.query.coord.length === 4)
          "
        >
          filtered by
          <span v-if="$route.query.query" class="assets__search-tags badge badge-primary ml-1">
            Search: {{ $route.query.query }}
            <span class="assets__search-remove-keyword" @click="clearKeyword" aria-hidden="true">&times;</span>
          </span>
          <span v-if="this.$route.query.date_range" class="badge badge-primary ml-1">
            From: {{ this.$route.query.date_range[0] }} To:
            {{ this.$route.query.date_range[1] }}
            <span class="assets__search-remove-dates" @click="clearDates" aria-hidden="true">&times;</span>
          </span>
          <span v-if="this.$route.query.coord && this.$route.query.coord.length === 4" class="badge badge-primary ml-1">
            Area: ({{ this.$route.query.coord[0] }}, {{ this.$route.query.coord[1] }}), ({{
              this.$route.query.coord[2]
            }}, {{ this.$route.query.coord[3] }})
            <span class="assets__search-remove-coords" @click="clearCoords" aria-hidden="true">&times;</span>
          </span>
          <span v-if="search.filters.length">
            <span
              v-for="(filter, idx) in search.filters"
              :key="idx"
              class="assets__search-tags badge badge-primary ml-1"
            >
              {{ filter.tagLabel }}
              <span class="assets__search-remove-filter" @click="removeFilter(idx)" aria-hidden="true">&times;</span>
            </span>
          </span>
          <span @click="clearSearch" class="assets__search-clear-all badge badge-primary ml-1">Clear Filter</span>
          <span
            v-if="auth && isUser"
            @click="openSaveFilterModal"
            class="assets__search-clear-all badge badge-primary ml-1"
            >Save Filter</span
          >
        </span>
        &nbsp;
        <span v-if="selectedAssets.length || globalSelectAll" class="form-group assets__selected-label">
          <label class="text-info mb-0">
            {{ selectedAssetsLabel }} asset<span v-show="selectedAssets.length > 1 || globalSelectAll">s</span>
            selected
          </label>
        </span>

        <!-- <button
          type="button"
          @click="clearFilters"
          class="assets__search-clear-filters btn btn-outline-primary btn-sm float-right border-0 badge badge-primary"
        >
          Clear All
        </button>-->
      </div>

      <!-- Sort and view results -->
      <div class="assets__controls clearfix mt-3" v-if="assets.length">
        <form class="assets__controls-form form-inline justify-content-between">
          <!-- <div class="float-right">
            <select class="assets__search-display-size form-control form-control-sm" v-model="search.size">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>-->

          <div class="form-group">
            <!-- Select all assets -->
            <div v-if="auth && isUser" class="d-inline-block ml-1">
              <button
                title="Select assets"
                type="button"
                class="btn-reset"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="icon icon-select text-primary bold-me" :class="clsIconSelect"></i>
              </button>
              <div class="dropdown-menu">
                <a class="assets__select-all dropdown-item" href="#" @click.prevent="manageGlobalSelectAll"
                  >Select All</a
                >
                <a class="assets__select-page dropdown-item" href="#" @click.prevent="selectPage">Select Page</a>
                <a class="assets__clear-all dropdown-item" href="#" @click.prevent="clearSelection">Clear Selection</a>
              </div>
            </div>
            <!-- Open in Datalab -->
            <button
              type="button"
              v-if="auth && isUser"
              class="assets__jupyter-lab btn-reset ml-1"
              v-show="selectedAssets.length || globalSelectAll"
              @click.prevent="openMultipleLabModal"
              title="Open in datalab"
            >
              <i class="icon icon-lab text-primary font-24"></i>
              <!-- <svg
                class="svg-36 svg-primary md-interactive"
                viewBox="0 0 500 500"
              >
                <title>Open in lab</title>
                <path
                  d="M162.9,385.6l45.6-91.2c2.2-4.4,5.7-8,10.1-10.4h0c6.5-3.5,14.4-3,20.4,1.3l13,9.4c8.3,5.9,20,4.3,26.2-3.6l0,0l53.2,94.5   c1.1,1.9-0.4,4.2-2.6,4.2H165.6C163.4,389.7,162,387.5,162.9,385.6z"
                />
                <path
                  d="M406.5,457.3H93.5c-8.2,0-15.6-4.1-19.9-11.1c-4.3-6.9-4.7-15.3-1.1-22.6l108.1-217v-83.5c-19-7.3-31.8-24.9-31.8-45.4   c0-27,22.3-49,49.7-49h87.8c13.5,0,26.1,5.2,35.5,14.7c9.2,9.3,14.3,21.5,14.2,34.5c-0.1,20.5-13,38.1-31.3,45.3v83.5l122.1,215.8   c4.1,7.2,4,16.1-0.2,23.2C422.6,452.8,414.8,457.3,406.5,457.3z M119.6,417.8h259.2L265.2,217.1V87.2H285c6.9,0,11.5-4.2,11.6-9.4   c0-3.1-1.5-5.2-2.7-6.5c-2-2-4.6-3-7.5-3h-87.8c-5.6,0-10.2,4.3-10.2,9.5s4.6,9.5,10.2,9.5h19.8l1.9,19.8v109L119.6,417.8z"
                />
              </svg>-->
            </button>

            <!-- Download selection -->
            <button
              type="button"
              v-if="auth && isUser"
              class="assets__download btn-reset"
              v-show="selectedAssets.length || globalSelectAll"
              @click.prevent="downloadAssets"
              title="Save to your workspace"
            >
              <i class="icon icon-export text-primary font-26"></i>
            </button>

            <!-- Save filter -->
            <!-- <button
              v-if="auth && isUser"
              type="button"
              class="assets__save-filter btn-reset"
              @click.prevent="openSaveFilterModal"
            >
              <i class="icon text-primary icon-add-filter bold-me"></i>
            </button> -->

            <!-- Download CSV metadata -->
            <button
              type="button"
              class="assets__download-csv btn-reset"
              v-if="auth"
              @click.prevent="downloadCsv"
              v-show="selectedAssets.length || globalSelectAll"
              title="Download CSV"
            >
              <i class="icon icon-csv text-primary font-26"></i>
              <!-- <svg
                class="svg-36 svg-primary md-interactive"
                viewBox="0 0 500 500"
              >
                <title>Download CSV</title>
                <rect x="151.1" y="196.2" width="158.1" height="39.5" />
                <rect x="151.1" y="275.3" width="158.1" height="39.5" />
                <path
                  d="M417.3,341h-29.1V151.7L269.7,33.2H111.5C89.8,33.2,72,51,72,72.7v316.2c0,21.7,17.6,39.5,39.3,39.5H167v27.4   c0,5.9,4.7,11.2,10.6,11.2h239.7c5.9,0,10.7-5.3,10.7-11.2V351C428,345.1,423.2,341,417.3,341z M111.5,388.9V72.7h138.4v98.8h98.8   V341H177.6c-5.9,0-10.6,4.1-10.6,10v37.9H111.5z M200.1,441c-5.4,0-9.3-4.4-9.3-10.4s4-10.4,9.4-10.4c5.4,0,9.3,4.4,9.3,10.4   C209.5,436.7,205.6,441,200.1,441z M245.1,427.1c5.2,0,8.6-1.4,11.4-2.8l2.9-1.4l2.8,13.1l-1.6,0.9c-3.1,1.8-9.5,3.8-17.2,3.8   c-18.1,0-30.3-13.4-30.3-33.3c0-20.4,13.3-34.6,32.4-34.6c6.6,0,12.3,1.8,15.2,3.4l1.7,0.9l-3.7,13.6l-2.8-1.8   c-1.8-1.1-5.1-2.5-10.4-2.5c-12.7,0-17.2,11-17.2,20.3C228.3,419,235,427.1,245.1,427.1z M282.9,440.9c-6.3,0-12.5-1.7-17-4.5   l-1.6-1l4.1-13.5l2.8,2c2.8,2,7.5,3.9,11.9,3.9c5.3,0,8.3-2.4,8.3-6.5c0-3.5-1.4-5.8-8.8-8.8c-13.5-5.2-16.3-13.4-16.3-19.4   c0-11.7,9.1-20.2,21.7-20.2c5.4,0,11,1.5,15.1,4.1l1.6,1l-4.1,13l-2.8-1.9c-1.3-0.9-5-3.1-10-3.1c-4.1,0-6.8,2.3-6.8,5.7   c0,3,1.3,4.7,9,7.9c11.2,4.6,16.2,11,16.2,20.5C306.2,432.8,297.1,440.9,282.9,440.9z M342.4,440h-13.2l-22.9-66h16.2l11.5,35.9   c0.8,2.5,1.6,5,2.4,7.5c0.7-2.4,1.5-4.9,2.4-7.5l11.4-35.9h16L342.4,440z"
                />
              </svg>-->
            </button>
            <!-- Share on social networks -->
            <div class="assets__share-social d-inline-block">
              <button
                type="button"
                class="btn-reset"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                title="Share"
              >
                <i class="icon icon-share text-primary bold-me"></i>
              </button>
              <div class="dropdown-menu">
                <a class="assets__share-gssc dropdown-item" :href="shareSiteEmailHref">Share GSSC via email</a>
                <a class="assets__share-search dropdown-item" :href="shareEmailHref">Share Search via email</a>
                <button type="button" class="assets__share-copy dropdown-item" :data-clipboard-text="absUrl">
                  Copy Search to clipboard
                </button>
              </div>
            </div>
            <!-- Select SortOption (grid mode only) -->
            <div class="assets__search-sort">
              <div class="dropdown">
                <button
                  title="Sort by"
                  id="dropdown-sort"
                  class="assets__search-sort-button btn-reset"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-flip="false"
                >
                  <i class="icon icon-sort-amount-asc text-primary"></i>
                </button>
                <div class="dropdown-menu">
                  <a
                    class="dropdown-item"
                    :class="clsActiveSort('recent')"
                    href="#"
                    @click.prevent="setSortOption('recent')"
                    >Most Recent</a
                  >
                  <a
                    class="dropdown-item"
                    :class="clsActiveSort('relevant')"
                    href="#"
                    @click.prevent="setSortOption('relevant')"
                    >Most Relevant</a
                  >
                  <a
                    class="dropdown-item"
                    :class="clsActiveSort('filename.asc')"
                    href="#"
                    @click.prevent="setSortOption('filename.asc')"
                    >Filename A-Z</a
                  >
                  <a
                    class="dropdown-item"
                    :class="clsActiveSort('filename.desc')"
                    href="#"
                    @click.prevent="setSortOption('filename.desc')"
                    >Filename Z-A</a
                  >
                  <a
                    class="dropdown-item"
                    :class="clsActiveSort('resource_type.asc')"
                    href="#"
                    @click.prevent="setSortOption('resource_type.asc')"
                    >Resource Type A-Z</a
                  >
                  <a
                    class="dropdown-item"
                    :class="clsActiveSort('resource_type.desc')"
                    href="#"
                    @click.prevent="setSortOption('resource_type.desc')"
                    >Resource Type Z-A</a
                  >
                </div>
              </div>
            </div>
            <!-- Select Columns (table mode only) -->
            <div v-if="viewMode != 'grid'" class="assets__search-show-columns">
              <div class="dropdown">
                <button
                  title="Show/Hide columns"
                  id="dropdown-columns"
                  class="btn-reset"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-flip="false"
                >
                  <i class="icon icon-columns text-primary font-24"></i>
                </button>
                <div class="dropdown-menu">
                  <asset-column-selector :filters="assetColumnSelectors" v-model="selectedColumns" />
                </div>
              </div>
            </div>
            <!-- Toggle list/card view mode -->
            <button
              type="button"
              class="assets__toggle-view btn-reset"
              @click="toggleViewMode"
              title="Cards/Table view"
            >
              <i class="icon text-primary" :class="clsIconViewMode"></i>
            </button>
            <!-- Add asset -->
            <!-- <button type="button" class="assets_add-new btn-reset" @click="openNewAssetModal">
              <i class="icon icon-add text-primary p-0 font-24"></i>
            </button> -->
            <!-- <div
              v-if="selectedAssets.length"
              class="form-group assets__selected-label-desktop"
            >
              <label class="ml-3 text-info"
                >{{ selectedAssetsLabel }} assets selected</label
              >
            </div>-->
          </div>

          <div class="form-group">
            <!-- <label
              class="assets__search-perpage-label mr-2"
              for="assets__search-perpage"
              >Assets per page</label
            >-->
            <select
              role="button"
              title="Assets per page"
              id="assets__search-size"
              class="assets__search-size form-control form-control-sm"
              v-model="search.size"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </select>
            <div v-show="pager.total_count" class="assets__results-pager-top ml-2">
              <!-- Pager -->
              <ul class="pagination pagination-sm m-auto">
                <li title="Previous page" class="page-item" :class="clsPagerBack">
                  <a class="page-link" href="#" aria-label="Previous" @click.prevent="setPage(pager.current_page - 1)">
                    <span aria-hidden="true">&lsaquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li class="page-item active">
                  <a class="page-link" href="#" @click.prevent="setPage(pager.current_page)">{{
                    pager.current_page
                  }}</a>
                </li>
                <li title="Next page" class="page-item" :class="clsPagerNext">
                  <a class="page-link" href="#" aria-label="Next" @click.prevent="setPage(pager.current_page + 1)">
                    <span aria-hidden="true">&rsaquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- <div class="float-right">
            <select class="assets__search-sort-order form-control form-control-sm" v-model="search.sortOrder">
              <option value="asc">asc.</option>
              <option value="desc">desc.</option>
            </select>
          </div>-->
        </form>
      </div>
      <div class="assets__search-results" :class="{ 'loader-on': showAssetLoader }">
        <!-- grid mode view -->
        <div v-if="viewMode == 'grid'" class="assets__search-results-grid row mb-3">
          <div class="col-md-6 mt-3" v-for="asset in assets" :key="asset.id">
            <asset
              :data="asset"
              v-model="asset.selected"
              @openModal="openAssetModal"
              @openAssetLab="openSingleLabModal"
              @input="assetCheckClicked(asset)"
            >
            </asset>
          </div>
        </div>

        <!-- list mode view -->
        <div v-else class="assets__search-results-list mb-3">
          <table id="table" class="table" :class="clsWrapped">
            <thead>
              <draggable v-model="userMovedColumns" draggable=".draggable" tag="tr">
                <!-- checkbox -->
                <th class="align-middle assets__expand-selector">
                  <div class="custom-control custom-switch d-flex align-items-center">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch1"
                      @input="wrapped = !wrapped"
                    />
                    <label role="button" class="custom-control-label" for="customSwitch1">Expand</label>
                  </div>
                </th>
                <th v-for="(col, idx) in allButFixedColumns" :key="idx" class="align-middle draggable">
                  <!-- button to toggle sort -->
                  <button
                    v-if="col in sortColumnIcons"
                    @click.prevent="toggleColumnSort(col)"
                    type="button"
                    class="assets__search-results-list-sorted btn-reset btn-sm align-middle"
                  >
                    <i class="icon text-primary px-0 ml-n1" :class="sortColumnIcons[col].icon"></i>
                  </button>
                  <span>{{ col }}</span>
                </th>
              </draggable>
            </thead>
            <tbody>
              <!-- @click.native="clearGlobalSelectAll" -->
              <asset-listing
                :data="asset"
                v-model="asset.selected"
                v-for="asset in assets"
                :key="asset.id"
                :displayedColumns="allButFixedColumns"
                :columnsMapping="columnsMapping"
                @openModal="openAssetModal"
                @openAssetLab="openSingleLabModal"
                @input="assetCheckClicked(asset)"
              ></asset-listing>
            </tbody>
          </table>
        </div>
        <!-- asset pagination loader -->
        <div v-if="showAssetLoader" class="loader-wrapper">
          <div class="loader-back"></div>
          <div class="main-loader">
            <img :src="wpData.image_path + 'loading-earth.png'" class="earth-image" />
            <img :src="wpData.image_path + 'loading-sat.png'" class="satellite-image rotate" />
          </div>
        </div>
      </div>

      <!-- asset modal view the last opened asset -->
      <asset-modal class="asset__modal" v-if="currentAsset" :data="currentAsset" @openAssetLab="openSingleLabModal" />

      <!-- <new-asset-modal class="new-asset-modal" /> -->

      <!-- asset lab modal to open assets in lab -->
      <asset-lab-modal
        class="asset__lab-modal"
        v-if="currentLab"
        :assets="currentLab.assets"
        :lab="currentLab.lab"
        :isProcessing="currentLab.isProcessing"
        :searchParams="searchParamsArrayOfObj"
        :selectAll="globalSelectAll"
        :initName="labInitName"
        :initDesc="labOrFilterInitDesc"
        @lab-ready="launchLab"
      />

      <!-- save filter modal -->
      <save-filter-modal
        class="assets__save-filter-modal"
        :query="searchParamsArrayOfObj"
        :initName="filterInitName"
        :initDesc="labOrFilterInitDesc"
      />

      <!-- message modal -->
      <message-modal
        class="message-modal"
        :title="modalTitle"
        :message="modalMessage"
        :okButtonText="modalOkText"
        :okCallbackFunction="okCallbackFunction"
        :cancel="false"
      />
      <!-- download message modal -->
      <download-message-modal
        class="download-message-modal"
        :title="modalTitle"
        :message="modalMessage"
        :cancel="true"
        :okButtonText="modalOkText"
        :cancelButtonText="modalCancelText"
        @confirmed="redirectToDownload"
      />
      <!-- selection message modal -->
      <selection-message-modal
        class="selection-message-modal"
        :title="modalTitle"
        :message="modalMessage"
        :cancel="true"
        :okButtonText="modalOkText"
        :cancelButtonText="modalCancelText"
        :okCallbackFunction="okCallbackFunction"
        :cancelCallbackFunction="cancelCallbackFunction"
        @confirmed="clearSelection"
      />
      <!-- day of year modal -->
      <day-of-year-modal
        class="day-of-year-modal"
        @dayOfYear="onDayOfYearChosen"
        :datePickerLocation="datePickerLocation"
        @openGPS="onGPSWeekSelected"
        @openCalendarDay="showCalendarDay"
        @closeModal="DOYCloseModal"
      />
      <!-- GPS Week modal -->
      <gps-week-modal
        class="gps-week-modal"
        @gpsWeek="onGPSWeekChosen"
        :datePickerLocation="datePickerLocation"
        @openDOY="onDayOfYearSelected"
        @openCalendarDay="showCalendarDay"
        @closeModal="gpsWeekCloseModal"
      />

      <div v-show="pager.total_count" class="assets__results-pager-bottom row">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <!-- Pager -->
            <ul class="pagination col-8">
              <!-- <li class="page-item" :class="clsPagerJumpBack">
                <a class="page-link" href="#" aria-label="First Page" @click.prevent="setPage(1)">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">First Page</span>
                </a>
              </li>-->
              <li title="Previous page" class="page-item" :class="clsPagerBack">
                <a class="page-link" href="#" aria-label="Previous" @click.prevent="setPage(pager.current_page - 1)">
                  <span aria-hidden="true">&lsaquo;</span>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
              <li v-for="i in pagerRange" class="page-item" :key="i" :class="{ active: i == pager.current_page }">
                <a class="page-link" href="#" @click.prevent="setPage(i)">
                  {{ i }}
                </a>
              </li>
              <li title="Next page" class="page-item" :class="clsPagerNext">
                <a class="page-link" href="#" aria-label="Next" @click.prevent="setPage(pager.current_page + 1)">
                  <span aria-hidden="true">&rsaquo;</span>
                  <span class="sr-only">Next</span>
                </a>
              </li>
              <!-- <li class="page-item" :class="clsPagerJumpForward">
                <a class="page-link" href="#" aria-label="Last Page" @click.prevent="setPage(pager.last_page)">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Last Page</span>
                </a>
              </li>-->
            </ul>
            <!-- Results -->
            <p class="text-secondary col-4 text-right">
              {{ pager.from.toLocaleString('en-US') }} - {{ pager.to.toLocaleString('en-US') }} of
              {{ pager.total_count.toLocaleString('en-US') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssetMap from '@/components/AssetMap.vue'
import AssetFilter from '@/components/AssetFilter.vue'
import AssetFilterModel from '@/models/asset_filter'
import ColumnSelectorModel from '@/models/column_selector'
import Asset from '@/components/Asset.vue'
import AssetListing from '@/components/AssetListing.vue'
import AssetColumnSelector from '@/components/AssetColumnSelector.vue'
import AssetModal from '@/components/AssetModal.vue'
// import NewAssetModal from '@/components/NewAssetModal.vue'
import AssetLabModal from '@/components/AssetLabModal.vue'
import SaveFilterModal from '@/components/SaveFilterModal.vue'
import MessageModal from '@/components/MessageModal.vue'
import DayOfYearModal from '@/components/DayOfYearModal.vue'
import GPSWeekModal from '@/components/GPSWeekModal.vue'
// import flatPickr from 'vue-flatpickr-component'
import ClipboardJS from 'clipboard'
import Vue from 'vue'
import helpers from '@/lib/helpers'
import DateRangePicker from '@/components/DateRangePicker.vue'
import * as api from '@/lib/api'
import draggable from 'vuedraggable'
import { VueAutosuggest } from 'vue-autosuggest'
import lucene from 'lucene'

const MAX_NUMBER_OF_FILTERS = 50

// Selectable asset columns
// const selectableColumns = [
//   'File Path',
//   'Description',
//   // 'Class',
//   'Organisation',
//   // 'Domains',
//   'Ob. Constellations',
//   'Ob. Satellites',
//   'Observables',
//   'Asset Type',
//   'Collection',
//   'Date',
// ]

function initSearch() {
  return {
    // grid mode sort option
    sortOption: 'recent',
    // list mode sort option
    sortColumn: '',
    sortColumnAsc: false, // false = sort descending
    size: 20,
    page: 1,
    filters: [],
  }
}

export default {
  name: 'assets',
  props: {
    wpData: {
      type: Object,
    },
    user: String,
  },
  components: {
    Asset,
    AssetListing,
    AssetFilter,
    AssetMap,
    AssetColumnSelector,
    AssetModal,
    AssetLabModal,
    SaveFilterModal,
    MessageModal,
    DayOfYearModal,
    GpsWeekModal: GPSWeekModal,
    // NewAssetModal,
    DownloadMessageModal: MessageModal,
    SelectionMessageModal: MessageModal,
    // flatPickr,
    DateRangePicker,
    draggable,
    VueAutosuggest,
  },
  data() {
    return {
      currentAsset: null,
      currentLab: null,
      assets: [],
      // give initial values to avoid "can´t read of undefined ... error"
      pager: { to: 0, from: 0, total_count: 0 },
      aggregation: [],
      pager_max_links: 7,
      filters: [],
      // keyword query needs click to search
      keyword: this.$route.query.query || '',
      // holds temporary item in autocomplete dropdown when click arrow up/down
      itemChanged: '',
      autocomplete: [],
      // date range
      dateFrom: null,
      dateTo: null,
      // datepickerConfig: {
      //   enableTime: true,
      // },
      // rectangle bounded region
      coords: [],
      toggleToApplyCoords: false,
      lat1: '',
      lng1: '',
      lat2: '',
      lng2: '',
      // auto-search if any of these options change
      search: initSearch(),
      // Hacky way to stop route from being synced on initial load
      // Seems not to be needed anymore ...
      needsSyncRoute: false,
      // appliedFilters: [],
      showMap: true,
      showPicker: false,
      viewMode: 'list',
      reRender: false, //ro real meaning, when value is changed component should reRender
      // model for column selector tree view
      selectableColumns: [],
      selectedColumns: [],
      userMovedColumns: [],
      columnsMapping: {},
      showSidebar: true,
      shareClipboard: null,
      csvBlob: '',
      //MessageModal vars
      modalTitle: '',
      modalMessage: '',
      modalOkText: 'Ok',
      modalCancelText: 'Cancel',
      cancelCallbackFunction: function() {},
      okCallbackFunction: function() {},
      downloadFolder: '',
      //Select all (all items to be selected, not only on current page)
      globalSelectAll: false,
      //When coming from route with filters, will need to reload assets for filters to be applied
      needsReloadAssets: false,
      //trick to force computation of labInitName and labInitDesc name and desc for labs
      compute: true,
      wrapped: true,
      // wpData,
      dragging: false,
      // selectedStations that are IN MAP
      selectedStations: [],
      // filteredStationsNames: null,
      selectedAssets: [],
      validStations: undefined,
      datePickerLocation: {},
      showAssetLoader: false,
      mapStations: null,
    }
  },
  computed: {
    auth() {
      return this.$store.getters.isAuthenticated
    },
    inputProps() {
      if (this.auth) {
        return {
          id: 'autosuggest__input',
          ref: 'searchInputRef',
          class: 'autosuggest__input form-control shadow-none',
          type: 'search',
          placeholder: 'Search GNSS Assets',
          autofocus: true,
          disabled: false,
          title: 'Search GNSS Assets',
        }
      } else {
        return {
          id: 'autosuggest__input',
          ref: 'searchInputRef',
          class: 'autosuggest__input form-control autosuggest__input-disabled',
          type: 'search',
          placeholder: 'Unavailable for anonymous users',
          autofocus: true,
          disabled: true,
          title: '',
          // title: 'Search temporarily disabled for unregistered users',
        }
      }
    },
    isSelf() {
      return this.$store.getters.isSelf
    },
    isUser() {
      return this.$store.getters.isUser
    },
    isAdmin() {
      return this.$store.getters.isAdministrator
    },
    storedSelectAll() {
      return this.$store.getters.storedSelectAll
    },
    storedSelection() {
      return this.$store.getters.storedSelection
    },
    // the absolute URL for the current search
    absUrl() {
      console.log('THIS ROUTE', this.$route)
      return process.env.VUE_APP_ENTRY_URL + this.$route.fullPath
    },
    shareSiteEmailHref() {
      return `mailto:?subject=GNSS Science Support Centre (GSSC)&body=The GNSS Science Support Centre (GSSC), located at ESAC, Madrid, Spain, is an initiative of the European Space Agency's Science Navigation Office to foster collaboration and research across scientific communities through the provision of information products and services regarding GNSS Infrastructures. --> ${
        process.env.VUE_APP_ENTRY_URL
      }`
    },
    // Href for share via email
    shareEmailHref() {
      const body = encodeURIComponent(this.absUrl)
      return `mailto:?subject=GSSC Search&body=${body}`
      // return `mailto:?subject=GSSC Search&body=${this.absUrl.replace(/&/g, '%26')}`
    },
    // Adjust width of content depending on whether sidebar is shown
    clsContent() {
      return {
        'col-md-10': this.showSidebar,
        col: !this.showSidebar,
      }
    },
    styleToggleSidebar() {
      if (this.showSidebar) {
        return {
          transform: 'rotate(180deg)',
        }
      }
      return {}
    },
    clsCoords() {
      // adjust little triangle if sidebar is closed
      return {
        sidebarClosed: !this.showSidebar,
      }
    },
    // selectedAssets() {
    //   return this.assets.filter((asset) => asset.selected)
    // },
    selectedAssetsLabel() {
      return this.globalSelectAll ? this.pager.total_count : this.selectedAssets.length
    },
    // clsToggleMap() {
    //   return {
    //     active: this.showMap,
    //   }
    // },
    clsToggleSidebarButton() {
      return {
        'd-none': this.showSidebar,
      }
    },
    clsIconViewMode() {
      switch (this.viewMode) {
        case 'list':
          return 'icon-grid'
        case 'grid':
          return 'icon-list p-0'
      }
    },
    allAssetsInPageAreSelected() {
      const all = this.assets.reduce(function(acc, asset) {
        return acc && asset.selected
      }, true)
      console.log('all', all)
      return all
    },
    clsIconSelect() {
      // return the ligature for the icon
      if (this.selectedAssets.length === 0 && !this.globalSelectAll) {
        // icon box-empty
        return 'icon-box-empty'
      } else if (this.allAssetsInPageAreSelected && !this.globalSelectAll) {
        return 'icon-box-tick'
      } else if (this.globalSelectAll) {
        // icon double-tick
        return 'icon-box-doubletick'
      } else {
        // icon box-line
        return 'icon-box-line'
      }
    },
    clsWrapped() {
      return this.wrapped ? 'wrapped' : ''
    },
    pagerStart() {
      // calculate the ideal pages per side
      const oneSide = parseInt(this.pager_max_links / 2)
      // calculate the max pages we can have to the left of current page
      const maxLeft = Math.min(this.pager.current_page - 1, oneSide)
      return this.pager.current_page - maxLeft
    },
    pagerEnd() {
      return Math.min(this.pagerStart + this.pager_max_links - 1, this.pager.last_page)
    },
    // work out the page numbers to display in results pager
    pagerRange() {
      // build range of links for v-for
      let links = []
      for (let i = this.pagerStart; i <= this.pagerEnd; i++) {
        links.push(i)
      }
      return links
    },
    clsPagerJumpBack() {
      return {
        disabled: this.pagerStart == 1,
      }
    },
    clsPagerBack() {
      return {
        disabled: this.pager.current_page == 1,
      }
    },
    clsPagerJumpForward() {
      return {
        disabled: this.pagerEnd == this.pager.last_page,
      }
    },
    clsPagerNext() {
      return {
        disabled: this.pager.current_page == this.pager.last_page,
      }
    },
    // build date range for search
    dateRange() {
      if (!this.dateFrom && !this.dateTo) {
        return null
      }

      const dateFrom = this.dateFrom ? this.dateFrom : '1980-01-01'
      const dateTo = this.dateTo ? this.dateTo : '2200-01-01'

      return [dateFrom, dateTo]
    },
    //separate basicParams, from filter params, added in searchParams"
    basicParams() {
      let params = {
        size: this.search.size,
        from: (this.search.page - 1) * this.search.size,
      }

      // Build sort options
      // if (this.viewMode === 'grid') {
      switch (this.search.sortOption) {
        case 'filename.asc':
          params.sort_by = 'filename'
          params.order_by = 'asc'
          this.search.sortColumn = 'Filename'
          this.search.sortColumnAsc = true
          break
        case 'filename.desc':
          params.sort_by = 'filename'
          params.order_by = 'desc'
          this.search.sortColumn = 'Filename'
          this.search.sortColumnAsc = false
          break
        case 'resource_type.asc':
          params.sort_by = 'resource_type.name'
          params.order_by = 'asc'
          this.search.sortColumn = 'Resource Type'
          this.search.sortColumnAsc = false
          break
        case 'resource_type.desc':
          params.sort_by = 'resource_type.name'
          params.order_by = 'desc'
          this.search.sortColumn = 'Resource Type'
          this.search.sortColumnAsc = false
          break
        case 'recent':
          params.sort_by = 'file.epo_first_name'
          params.order_by = 'desc'
          this.search.sortColumn = 'Date'
          this.search.sortColumnAsc = false
          break
        case 'relevant':
          params.sort_by = '_score'
          params.order_by = 'desc'
          break
        case 'column':
          params.sort_by = this.sortableColumns[this.search.sortColumn]
          params.order_by = this.search.sortColumnAsc ? 'asc' : 'desc'
      }
      // } else {
      //   // Map label to API field
      //   params.sort_by = this.sortableColumns[this.search.sortColumn]
      //   params.order_by = this.search.sortColumnAsc ? 'asc' : 'desc'
      // }
      return params
    },
    // Gather the parameters and filters for the search query
    searchParams() {
      //replicate object so date range and filters are not added twice
      let params = Object.assign({}, this.basicParams)
      // Build date range
      if (this.dateRange !== null) {
        params.date_range = this.dateRange
      }
      // Build region filter if we are searching via map
      // if (this.showMap) {
      // if (this.coords.length == 4) params.coord = this.coords
      // } else if (this.keyword) {
      // pass in query if searching via search box query
      if (this.keyword) params.query = this.keyword
      // }
      params = {
        ...params,
        ...this.searchFilters,
      }
      return params
    },
    // the route query params required to reproduce the same search
    routeQuery() {
      let query = {
        vuePage: this.search.page,
        size: this.search.size,
        // note the search mode
        mode: this.showMap ? 'map' : 'query',
      }
      query.sortOption = this.search.sortOption
      if (query.sortOption === 'column') {
        query.sortColumn = this.search.sortColumn
        query.sortColumnAsc = this.search.sortColumnAsc
      }
      if (this.keyword) {
        //&& !this.showMap) {
        query.query = this.keyword
      }
      // add region coordinates
      // if (this.coords.length == 4) {
      //   //&& this.showMap) {
      //   query.coord = this.coords
      // }

      // add date range
      if (this.dateRange) {
        query.date_range = this.dateRange
      }
      // if (this.dateFrom) {
      //   query.dateFrom = this.dateFrom;
      // }
      // if (this.dateTo) {
      //   query.dateTo = this.dateTo;
      // }

      // add filters
      for (const field in this.searchFilters) {
        // query[`_f_${field}`] = this.searchFilters[field];
        query[`${field}`] = this.searchFilters[field]
      }

      // console.log('stationsss before map selection', query['station_/_platform'])

      // // if some stations have been selected from the MAP
      // if (this.selectedStations) {
      //   //and it is not empty
      //   if (this.selectedStations.length > 0) {
      //     console.log('Newstationsss ROUTE QUERY UPDATED with ', this.selectedStations)
      // merge all station/platform filters removing duplicates
      // const stationsQuery = query['station_/_platform']
      // if (stationsQuery) {
      //   query['station_/_platform'] = [...new Set([...query['station_/_platform'], ...this.selectedStations])]
      // } else {

      // las estaciones que estén filtradas pero no en map van por su cuenta y las guardo en "restStations"
      let restStations = []
      if (query['station_/_platform']) {
        restStations = query['station_/_platform'].filter((station) => !this.mapStationsIds.includes(station))
      }
      if (this.selectedStations.length > 0) {
        query['station_/_platform'] = [...new Set([...this.selectedStations.slice(), ...restStations])]
      } else if (restStations.length > 0) {
        query['station_/_platform'] = restStations
      } else {
        // this is needed or an empty array remains
        delete query['station_/_platform']
      }
      // }
      // } else {
      //   query['station_/_platform'] = []
      //   }
      // }

      console.log('ROUTEQUERY', query)
      return query
    },
    // Convert search filters model to a more convenient format
    searchFilters() {
      const filters = {}
      console.log('THIS.SEARCH.FILTERS', this.search.filters)

      this.search.filters.forEach((model) => {
        // each filter can have multiple values which are OR'ed
        const filter = filters[model.field] || []
        filter.push(model.val)
        filters[model.field] = filter
      })
      console.log('SEARCHFILTERS', filters)
      return filters
    },
    // Need array of objects for API post("analysis-services/instances")
    searchFiltersArrayOfObj() {
      const filters = []
      const keys = Object.keys(this.searchFilters).forEach((key) =>
        this.searchFilters[key].forEach((child) => filters.push(Object.assign({ [key]: child })))
      )
      console.log('searchFiltersArrayOfObjs', filters)
      return filters
    },
    // Need array of objects for API post("analysis-services/instances")
    searchParamsArrayOfObj() {
      let params = Object.assign({}, this.basicParams)
      console.log('basicParams', this.basicParams)
      // If globalselectall DO NOT send size to API request
      if (this.globalSelectAll) delete params.size
      // Convert date Range to ArrayOfObj
      let dateRangeArrayOfObj = []
      if (this.dateRange) {
        dateRangeArrayOfObj = this.dateRange.map((date) => Object.assign({ date_range: date }))
      }
      // Convert coord to ArrayOfObj
      let coordArrayOfObj = []
      // if (this.showMap) {
      // if (this.coords.length == 4) {
      //   coordArrayOfObj = this.coords.map((coord) => Object.assign({ coord: coord }))
      // }
      // } else if (this.keyword) {
      // pass in query if searching via search box query
      params.query = this.keyword
      // }
      params = [
        ...Object.keys(params).map((k) => Object.assign({ [k]: params[k].toString() })),
        ...this.searchFiltersArrayOfObj,
        ...dateRangeArrayOfObj,
        ...coordArrayOfObj,
      ]
      console.log('searchParamsArrayOfObj - SAVED PARAMS', params)
      return params
    },
    // Define sortable columns and map label to field key for API
    sortableColumns() {
      // TODO: HARD CODED TO REMOVE DOI FIELD.
      // WHEN SOLVED IT SHOULD BE JUST return this.columnsMapping AS BEFORE.
      let tempSortable = Object.assign({}, this.columnsMapping)
      delete tempSortable.DOI
      return tempSortable

      // GOOD ONE
      // return this.columnsMapping

      // EVEN OLDER
      // return {
      //   Filename: 'filename',
      //   // Class: 'collection.class_aux',
      //   Organisation: 'collection.organisation.name',
      //   // Domains: 'collection.service_domains.name',
      //   // Satellites: 'data.statistics.group_data.sat_name',
      //   'Resource Type': 'resource_type.name',
      //   Collection: 'collection.name',
      //   'Generation Time': 'generation_time',
      //   'Ingestion Time': 'ingestion_time',
      // }
    },
    sortColumnIcons() {
      const columns = {}
      for (const col of Object.keys(this.sortableColumns)) {
        let icon
        if (this.search.sortColumn === col) {
          icon = this.search.sortColumnAsc ? 'icon-expand_less' : 'icon-expand_more'
        } else {
          icon = 'icon-unfold_more'
        }
        columns[col] = {
          icon,
        }
      }

      return columns
    },
    //Possible columns for list view mode
    displayedColumns() {
      const columns = []
      for (const model of this.selectedColumns) {
        columns[model.label] = true
      }

      // Always display filename
      const displayedColumns = [] //= ['Filename']

      for (let column of this.selectableColumns) {
        if (column in columns) {
          displayedColumns.push(column)
        }
      }
      return displayedColumns
    },
    allButFixedColumns() {
      return this.userMovedColumns.slice(1)
    },
    assetColumnSelectors() {
      return this.selectableColumns.map((label) => new ColumnSelectorModel(label))
    },
    selectedAssetsList() {
      return this.selectedAssets.map((asset) => {
        return {
          'asset-id': asset.id,
          'asset-location': asset.path,
        }
      })
    },
    labInitName() {
      this.compute
      const today = new Date()
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      const time =
        ('0' + today.getHours()).slice(-2) +
        ':' +
        ('0' + today.getMinutes()).slice(-2) +
        ':' +
        ('0' + today.getSeconds()).slice(-2)
      const dateTime = date + ' ' + time
      return `${dateTime}`
    },
    filterInitName() {
      return `My Filter ${this.labInitName}`
    },
    labOrFilterInitDesc() {
      this.compute
      let initDesc = ''
      initDesc += this.keyword ? `Search: ${this.keyword} | ` : ''
      initDesc += this.$route.query.date_range
        ? `From: ${this.$route.query.date_range[0]} To: ${this.$route.query.date_range[1]} | `
        : ''
      initDesc +=
        this.$route.query.coord && this.$route.query.coord.length === 4
          ? `Area: (${this.$route.query.coord[0]},${this.$route.query.coord[1]}),(${this.$route.query.coord[2]},${
              this.$route.query.coord[3]
            }) | `
          : ''
      initDesc += this.search.filters.length
        ? this.search.filters.map((filter) => filter.tagLabel).join(', ') + ' | '
        : ''
      return initDesc
    },
    availableStations() {
      const availableStations = this.aggregation.find((agg) => {
        if (agg.key === 'station_/_platform') {
          return true
        } else {
          return false
        }
      })
      const availableStationNames = availableStations ? availableStations.values.map((value) => value.name) : []
      console.log('stations avcalc', availableStationNames)
      return availableStationNames
    },
    computedSelectedStations() {
      return this.selectedStations.slice()
    },
    networks() {
      // need to return undefined, so that the networks dropdown is not loaded until some networks are available from this.aggregation
      // console.log(
      //   'NETWORKS',
      //   this.aggregation.find((el) => el.key === 'network_/_organisation').values.map((el) => el.name),
      // )
      let networks = undefined
      if (this.aggregation.length > 0) {
        networks = this.aggregation.length
          ? this.aggregation.find((el) => el.key === 'network_/_organisation').values.map((el) => el.name)
          : undefined
      }
      return this.aggregation.length ? networks : []
    },
    mapStationsIds() {
      if (this.mapStations) {
        return this.mapStations.map((station) => station.id)
      }
      return []
    },
  },
  methods: {
    testButton() {
      this.$router.push({
        name: 'assets',
        query: this.routeQuery,
      })
    },
    selectPage() {
      this.globalSelectAll = false
      this.$store.dispatch('saveSelectAll', this.globalSelectAll)
      this.assets.forEach((asset) => (asset.selected = true))
      // Add seletedAssets that were not previously added
      const newAssets = this.assets.filter(
        (asset) => this.selectedAssets.findIndex((item) => item.id == asset.id) == -1
      )
      this.selectedAssets = this.selectedAssets.concat(newAssets)

      console.log('all', this.selectedAssets)

      // console.log(
      //   'all selectpage',
      //   this.assets.filter((asset) => this.selectedAssets.findIndex(((item) => item.id === asset.id) === -1)),
      // )
    },
    manageGlobalSelectAll() {
      this.globalSelectAll = true
      this.$store.dispatch('saveSelectAll', this.globalSelectAll)
      this.assets.forEach((asset) => (asset.selected = true))
      this.selectedAssets = []
    },
    clearSelection() {
      this.globalSelectAll = false
      this.$store.dispatch('saveSelectAll', this.globalSelectAll)
      this.assets.forEach((asset) => (asset.selected = false))
      this.selectedAssets = []
      this.saveAssetsToStore()
    },
    // NOT USED
    // clearGlobalSelectAll() {
    //   if (this.globalSelectAll) {
    //     this.globalSelectAll = false
    //     this.clearSelection()
    //   }
    // },
    assetCheckClicked(asset) {
      console.log('SELECTION', asset)
      // check if asset is already in the list of selected
      const selected = this.selectedAssets.findIndex((item) => item.id == asset.id) != -1
      // Add to selection assets if global SelectAll is false and not already selected
      if (!this.globalSelectAll && !selected && asset.selected) {
        this.selectedAssets.push(asset)
      }
      // Remove from selected if asset clicked was unselected
      if (!this.globalSelectAll && selected && !asset.selected) {
        const pos = this.selectedAssets.findIndex((el) => el.id === asset.id)
        if (pos >= 0) this.selectedAssets.splice(pos, 1)
      }
      if (this.globalSelectAll) {
        Vue.nextTick(() => {
          this.selectedAssets = []
          this.assets.forEach((asset) => (asset.selected = true))
        })
        this.launchConfirmSelectionLostModal(function() {}, function() {})
        // this.clearSelection()
      }
    },
    launchConfirmSelectionLostModal(okCallbackFunction, cancelCallbackFunction) {
      this.modalTitle = 'Selection will be lost'
      this.modalMessage = 'Your current asset selection will be lost'
      this.modalOkText = 'Confirm'
      this.modalCancelText = 'Cancel'
      this.okCallbackFunction = okCallbackFunction
      this.cancelCallbackFunction = cancelCallbackFunction
      $('.selection-message-modal').modal()
      // reselect all assets, in case user cancels
    },
    saveAssetsToStore() {
      this.$store.dispatch('saveSelection', this.selectedAssets)
      // this.selectedAssets.forEach((asset) => {
      //   this.$store.commit('addCartItem', asset)
      // })
    },
    removeFilter(idx) {
      // create func variable to reuse
      const actuallyRemoveFilter = () => {
        this.search.page = 1
        // remove filter from selectedStations (if was one)
        this.selectedStations = this.selectedStations.filter((station) => station !== this.search.filters[idx].theVal)
        // remove filter from search results
        this.search.filters.splice(idx, 1)
      }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallyRemoveFilter, () => {})
      } else {
        actuallyRemoveFilter()
      }
    },
    clearFilters() {
      this.search.filters = []
      // this.getAssets();
    },
    clearSearch() {
      console.log('clearsearch')
      const actuallyClearSearch = () => {
        this.keyword = ''
        this.dateFrom = null
        this.dateTo = null
        this.selectedStations = []
        this.clearCoords()
        this.search = initSearch()
        this.clearSelection() // clear selection if there was
        this.syncRoute()
      }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallyClearSearch, () => {})
      } else {
        actuallyClearSearch()
      }
    },
    clearKeyword() {
      const actuallyClearKeyword = () => {
        this.keyword = ''
        this.$route.query.query = ''
        this.search.page = 1
        this.clearSelection() // clear selection if there was
        this.syncRoute()
      }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallyClearKeyword, () => {})
      } else {
        actuallyClearKeyword()
      }
    },
    clearDates() {
      const actuallyClearDates = () => {
        this.dateFrom = null
        this.dateTo = null
        this.$route.query.date_range = []
        this.search.page = 1
        this.clearSelection() // clear selection if there was
        this.syncRoute()
      }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallyClearDates, () => {})
      } else {
        actuallyClearDates()
      }
    },
    clearCoords() {
      const actuallyClearCoords = () => {
        this.coords = []
        this.$route.query.coords = []
        this.search.page = 1
        this.clearSelection() // clear selection if there was
        this.syncRoute()
      }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallyClearCoords, () => {})
      } else {
        actuallyClearCoords()
      }
    },
    setPage(page) {
      console.log('set page to ', page)
      this.search.page = page
      this.syncRoute()
      if (this.globalSelectAll) {
        this.assets.forEach((asset) => (asset.selected = true))
      }
    },
    // clearCoords() {
    //   this.coords = []
    // },
    // Set coords in model from array of coords in AssetMap
    // setCoords(coords) {
    //   this.coords = coords
    //   // Set individual variables for render
    //   if (coords.length == 4) {
    //     ;[this.lat1, this.lng1, this.lat2, this.lng2] = coords
    //   } else {
    //     this.lat1 = ''
    //     this.lng1 = ''
    //     this.lat2 = ''
    //     this.lng2 = ''
    //   }
    // },
    // Set coords on map from user input
    coordsInputted() {
      this.lat1 = helpers.between(this.lat1, -90, 90)
      this.lng1 = helpers.between(this.lng1, -180, 180)
      this.lat2 = helpers.between(this.lat2, -90, 90)
      this.lng2 = helpers.between(this.lng2, -180, 180)

      this.coords = []
      if (this.lat1 && this.lng1 && this.lat2 && this.lng2) {
        this.coords = [this.lat1, this.lng1, this.lat2, this.lng2]
      }
    },
    setSortOption(sortOption) {
      this.search.sortOption = sortOption
    },
    clsActiveSort(sortOption) {
      return this.search.sortOption === sortOption ? 'active' : ''
    },
    applyNewSearch() {
      // FUNCTION DEFINITION
      const actuallyApplyNewSearch = () => {
        console.log('LUCENE ACTUALLY APPLY')
        // clear selected items if there were any
        this.clearSelection()
        //apply syncRoute resetting page number to 1
        this.search.page = 1
        // sync Route
        this.syncRoute()
      }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallyApplyNewSearch, () => {})
      } else {
        if (this.checkLucene(this.keyword)) {
          actuallyApplyNewSearch()
        }
      }
    },
    checkLucene(keyword) {
      let luceneError = false
      try {
        lucene.parse(keyword)
      } catch (err) {
        luceneError = true
        this.keyword = ''
        this.syncSearchParams()
      } finally {
        if (luceneError) {
          console.log('LUCENE ERROR - POPUP')
          this.modalTitle = 'Wrong Syntax'
          this.modalMessage =
            'The search needs to conform to <a href="https://lucene.apache.org/core/2_9_4/queryparsersyntax.html">Apache Lucene Syntax</a>.'
          this.modalOkText = 'Ok'
          $('.message-modal').modal()
          return false
        } else {
          console.log('LUCENE NO ERROR')
          return true
        }
      }
    },
    applyCoords() {
      console.log('applyCoords')
      const actuallyApplyCoords = () => {
        // toogle variable to trigger applyCoords in AssetMap
        this.toggleToApplyCoords = !this.toggleToApplyCoords
      }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallyApplyCoords, () => {})
      } else {
        actuallyApplyCoords()
      }
    },
    // New procedure to convert coords to selected stations
    // applyNewCoords() {
    //   // console.log(this.$refs.assetMapRef)
    //   this.$refs.assetMapRef.applyStationsFilter()
    // },
    syncRoute(test) {
      if (test) console.log('syncroute', test)
      // No need to sync route on initial page load
      if (this.needsSyncRoute) {
        console.log('all syncRoute', this.routeQuery)
        console.log('SYNCROUTE ASSETS ROUTER PUSH')
        this.$router.push({
          name: 'assets',
          query: this.routeQuery,
        })
      } else {
        // Sync route next time this is called
        this.needsSyncRoute = true
      }
    },
    // Runs when a filter is clicked from the tree
    changeFilters(newSelection) {
      console.log('CHANGE FILTERS', newSelection)
      const actuallyChangeFilters = () => {
        // Reset selection if any
        this.clearSelection()
        // need to do this wat to reset page to 1
        this.search.page = 1
        this.search.filters = newSelection
        this.selectedStations = this.search.filters
          .filter(
            (assetFilter) =>
              assetFilter.theField === 'station_/_platform' && this.mapStationsIds.includes(assetFilter.theVal)
          )
          .map((assetFilter) => assetFilter.theVal)
      }
      // console.log('NUMBER OF FILTERS', newSelection.length)
      // if (newSelection.length > MAX_NUMBER_OF_FILTERS) {
      //   this.showMaxNumberOfFiltersModal()
      //   return
      // }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallyChangeFilters, () => {})
      } else {
        actuallyChangeFilters()
      }
    },
    showMaxNumberOfFiltersModal() {
      this.modalTitle = 'Too many filters selected'
      this.modalMessage = `Maximum number of filters (${MAX_NUMBER_OF_FILTERS}) has been reached.`
      this.modalOkText = 'Ok'
      $('.message-modal').modal()
    },
    syncSearchParams(needsSyncRoute = true) {
      console.log('syncsearchparams route is now: ', this.$route.query)
      console.log('syncsearchparams filters now are', this.search.filters)
      this.needsSyncRoute = needsSyncRoute
      console.log('syncsearchparams')
      this.keyword = this.$route.query.query || ''
      this.search.size = this.$route.query.size || 20
      console.log('$ROUTE FROM BROWSER', this.$route.query)
      this.search.page = this.$route.query.vuePage || 1
      this.search.sortOption = this.$route.query.sortOption || 'recent'
      this.dateFrom = this.$route.query.date_range ? this.$route.query.date_range[0] : null
      this.dateTo = this.$route.query.date_range ? this.$route.query.date_range[1] : null
      // if (this.$route.query.mode === 'map') {
      // this.setCoords(this.$route.query.coord || [])
      // }
      this.showMap = this.$route.query.mode !== 'query' //|| this.$route.query.coord
      // const raw = this.$route.query
      // const filtered = Object.keys(raw)
      //   .filter(key => Object.keys(this.aggregation).includes(key))
      //   .reduce((obj, key) => {
      //     obj[key] = raw[key];
      //     return obj;
      //   }, []);
      //this.search.filters = filtered

      // DO THIS IN ANOTHER FUNCTION TO CALL AFTER SYNCSEARCHPARAMS ONLY WHERE NEEDED
      // E.G. NOT NEEDED IN MOUNTED ...
      const stationsQuery = this.$route.query['station_/_platform']

      if (Array.isArray(stationsQuery)) {
        this.selectedStations = stationsQuery.filter((station) => this.mapStationsIds.includes(station))
      } else if (this.mapStationsIds.includes(stationsQuery)) {
        this.selectedStations = [stationsQuery]
      } else {
        this.selectedStations = []
      }
      // this.selectedStations = stationsQuery
      //   ? Array.isArray(stationsQuery)
      //     ? stationsQuery.slice()
      //     : [stationsQuery]
      //   : []

      // SYNC search.filters
      // search.filters son los filtros que van a estar seleccionados en el panel izquierdo

      // First of all:
      // keep all "non-station" filters selected
      // keep all "station" filters selected that are NOT in map
      const filtersToKeep = this.search.filters.filter(
        (assetFilter) =>
          assetFilter.theField !== 'station_/_platform' ||
          // (assetFilter.theField === 'station_/_platform' &&
          //   this.selectedStations.includes(assetFilter.theVal)) ||
          (assetFilter.theField === 'station_/_platform' && !this.mapStationsIds.includes(assetFilter.theVal))
      )
      this.search.filters = filtersToKeep
      console.log('filtersToKeep', filtersToKeep)

      // Second:
      // Add "station" filters selected that ARE in map
      if (this.filters.length > 0) {
        // get all station filters models
        let stationFilters = []
        const rootStationFilters = this.filters.find((filter) => filter.label == 'Station / Platform')
        // check for undefined
        if (rootStationFilters && rootStationFilters.children[5] && rootStationFilters.children[5].modalFilters) {
          // check for empty array
          if (rootStationFilters.children[5].modalFilters.length > 0) {
            stationFilters = rootStationFilters.children[5].modalFilters
          }
        }
        // filter station filters that are selected
        const filterModels = stationFilters.filter((model) => this.selectedStations.includes(model.label))
        // add selected filter models to search.filters
        this.search.filters.push(...filterModels)
      }
    },
    async getAssets(withAggregations = true) {
      let response = null
      if (withAggregations) {
        response = await api.getAssets(this.searchParams)
        this.$emit('finishLoading')
      } else {
        // without Aggregations
        this.$emit('finishLoading')
        this.showAssetLoader = true
        response = await api.getAssetsNoAggregations(this.searchParams)
        this.showAssetLoader = false
      }
      console.log('ASSETS', response)
      if (helpers.checkErrMessage(response)) {
        console.log('RESPONSE ERROR IS', response.error)
        // If error is due session expired, just reload, the credentials are removed in errorCatcher
        if (response.error.includes('Session expired')) {
          console.log('RESPONSE ERROR INSIDE IS', response.error)
          console.log(response.error)
          window.location.reload()
          return
        }
        // For any other error, show the error and suggest to reload
        this.modalTitle = 'An Error Occurred'
        this.modalMessage = response.error
        this.modalOkText = 'Reload'
        this.okCallbackFunction = function() {
          window.location.reload()
        }
        $('.message-modal').modal()
        console.log('IT IS AN ERROR', response.message)
      }
      if (response) {
        const assets = response.results
        console.log('COLUMNS', response.columns)
        this.selectableColumns = response.columns.map((el) => el.field_renamed)
        this.selectedColumns = this.assetColumnSelectors.slice()
        this.columnsMapping = response.columns.reduce((acc, column) => {
          let { field_name, field_renamed } = column
          return { ...acc, [field_renamed]: field_name }
        }, {})
        console.log('columnsMapping', this.columnsMapping)
        // note the currently applied filters for this API call
        // this.appliedFilters = this.search.filters.slice();
        // console.log('ASSETS ARE ', assets)
        this.assets = assets.map((asset) => ({
          ...asset,
          selected: false,
        }))
        // Set pager
        this.pager = response.pagination
        // if needs build aggregations
        if (withAggregations) {
          // Set aggregations and build filter models
          this.aggregation = response.aggregation
          // console.log('aggregation', this.aggregation)
          this.buildAssetFilters(this.aggregation)
        }
        //In buildAssetFilters if buckets are detected from route that are not
        //applied, get Assets needs to be relaunched
        this.syncRoute('SYNCROUTE FROM GET ASSETS')

        if (this.needsReloadAssets) {
          this.needsReloadAssets = false
          console.log('GET ASSETS - NEEDSRELOADASSETS')
          this.$emit('showLoader')
          await this.getAssets()
        }
        // init clipboard for share link
        this.initShareClipboard()
      }
    },
    initShareClipboard() {
      if (this.shareClipboard) {
        this.shareClipboard.destroy()
      }
      if (this.assets.length > 0) {
        this.shareClipboard = new ClipboardJS('.assets__share-copy')
      }
    },
    // build asset filters given raw aggregation response from assets API
    // Initially select the provided filter labels
    buildAssetFilters(aggregation) {
      console.log('BUILDASSETFILTERS', this.$route.query)
      //cambio por NEWAPI
      const filterOrder = aggregation.map((agg) => agg.key)
      // Build new filters based on aggregation response
      let newFilters = []
      // Initialize to current selectedFilters
      let selectedFilters = this.search.filters
      filterOrder.forEach((field) => {
        //Take field remove '_' and 'metadata', and capitalize words
        const label = helpers.getCleanLabel(field)
        //.replace(/_/g, " ").replace("metadata", " ")
        //.split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
        const apiField = field //fieldMapping[field];

        // Find existing filter
        let filterModel = this.filters.find((model) => model.label === label)
        if (!filterModel) {
          filterModel = new AssetFilterModel(label)
        }

        // Sync aggregations with existing buckets
        // We cannot simply set filters to empty array and rebuild
        // Because we need to keep the selected status on the current filter objects
        // So the easiest way is to add/delete filters as required

        //if (Array.isArray(aggregation[field]) && aggregation[field].length) {
        //NEWAPI
        const aggregationValues = aggregation.find((o) => o.key == field).values
        if (Array.isArray(aggregationValues) && aggregationValues.length) {
          // Display this filter
          newFilters.push(filterModel)
          // Add buckets for this filter
          // buckets le llama a cada elemento hijo.
          let addBuckets = []
          const childrenByLabel = filterModel.fullChildrenByLabel
          const newChildrenByLabel = aggregationValues.reduce(
            (bylabel, bucket, idx) => ({ ...bylabel, [bucket.name]: idx }),
            {}
          )
          aggregationValues.forEach((bucket) => {
            let model
            if (bucket.name in childrenByLabel) {
              // Bucket already exists
              model = childrenByLabel[bucket.name].child
            } else {
              // Create bucket and add to filters if not found
              model = new AssetFilterModel(bucket.name)
              model.setParentLabel(label)
              model.setField(apiField)
              // For constellation filter, need to pass in bucket key instead of name
              if (field === 'constellation') {
                model.setVal(bucket.key)
              } else {
                model.setVal(bucket.name)
              }
              addBuckets.push(model)
            }
            model.setCount(bucket.doc_count)
            // Select the bucket if not already selected
            // THIS IS THE CASE WHEN A USER HAS CLICKED A NEW FILTER
            const isSelected = this.search.filters.find((filter) => filter.tagLabel == model.tagLabel)
            // If the filter is the selected list (this.search.filters) we eed to remove the "old" model from the list, and add the "new" model.
            if (isSelected) {
              selectedFilters = selectedFilters.filter((filter) => filter.tagLabel != model.tagLabel)
              selectedFilters.push(model)
            }
            // Active filters may be string or array depending on whether multiple buckets for the same filter are selected
            // console.log('apiField', apiField)
            // THIS IS TO CONSIDER THE FILTERS THAT COME SELECTED FROM THE QUERY
            const activeBuckets = this.$route.query[apiField]
            // console.log('activeBuckets', activeBuckets)
            const bucketNameOrKey = field === 'constellation' ? bucket.key : bucket.name
            if (activeBuckets && activeBuckets.includes(bucketNameOrKey) && !isSelected) {
              // console.log({ bucketNameOrKey })
              // Select the bucket but don't sync route
              console.log('HEY HEY ... pushing in filter ', bucket.name, model.tagLabel)
              selectedFilters.push(model)
              // THIS RELOAD IS STILL NEEDED FOR WHEN HAVING FILTERS DIRECTLY IN ROUTE IN INITIAL LOAD.
              // NEEDS TO LOAD ASSETS AND AGGREGATIONS, AND THEN RELOAD WITH APPROPRIATE FILTERS.
              // TODO: IS THERE ANOTHER SOLUTION? MAYBE CALL THE BACKEND WITH "ANYTHING" YOU GET IN THE ROUTE THAT IS NOT RECOGNIZED LIKE DATE, PAGE ETC., BUT THAT CAN GIVE ERRORS.
              this.needsReloadAssets = true
              this.needsSyncRoute = false
            }
          }) //aggregation[field].forEach((bucket)
          // Keep only the needed buckets
          const keepBucketIdxs = []
          Object.keys(childrenByLabel).forEach((label) => {
            if (label in newChildrenByLabel) {
              keepBucketIdxs.push(childrenByLabel[label].idx)
            }
          })
          filterModel.keepOnly(keepBucketIdxs)

          // Add buckets
          // console.log('field', field)
          const sortByCount = field !== 'sampling_rate'
          filterModel.addChildren(addBuckets, sortByCount)
        }
        this.search.filters = selectedFilters
      }) // filterOrder.forEach((field)

      // Render new filters
      console.log({ newFilters })
      this.filters = newFilters
    },
    toggleMap() {
      this.showMap = !this.showMap
      this.reRender = !this.reRender
      if (this.showMap) {
        this.$nextTick(() => this.$refs.lat1Ref.focus())
      }
      //this.clearFilters()
    },
    toggleViewMode() {
      if (this.viewMode === 'grid') {
        this.viewMode = 'list'
      } else {
        this.viewMode = 'grid'
      }
    },
    // Used to toggle sort in list view mode
    toggleColumnSort(column) {
      if (this.search.sortColumn === column) {
        // Toggle sort direction
        this.search.sortColumnAsc = !this.search.sortColumnAsc
      } else {
        this.search.sortColumn = column
        this.search.sortColumnAsc = true
      }
      console.log(this.search.sortColumn)
      this.search.sortOption = 'column'
      // if sorted by Filename, select sortOption in dropdown
      if (this.search.sortColumn === 'Filename') {
        if (this.search.sortColumnAsc) {
          this.search.sortOption = 'filename.asc'
        } else {
          this.search.sortOption = 'filename.desc'
        }
      }
      // if sorted by Resource Type, select sortOption in dropdown
      if (this.search.sortColumn === 'Resource Type') {
        if (this.search.sortColumnAsc) {
          this.search.sortOption = 'resource_type.asc'
        } else {
          this.search.sortOption = 'resource_type.desc'
        }
      }
      // if sorted by Date desc, select sortOption recent in dropdown
      if (this.search.sortColumn === 'Date' && !this.search.sortColumnAsc) {
        this.search.sortOption = 'recent'
      }
      // Just call assets API here
      // TODO: put sort column options into route?
      console.log('GET ASSETS - AFTER COLUMN SORT')
      this.getAssets()
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar
      this.reRender = !this.reRender
    },
    // Set view asset modal data and open
    openAssetModal(data) {
      // First set the current asset data
      this.currentAsset = data
      // Open modal on next DOM update
      Vue.nextTick(() => {
        $('.asset__modal').modal()
      })
    },
    // openNewAssetModal() {
    //   // Open modal on next DOM update
    //   console.log('open new asset modal')
    //   Vue.nextTick(() => {
    //     $('.new-asset-modal').modal()
    //   })
    // },
    // Set open in lab modal data
    openSingleLabModal(data, lab, isProcessing) {
      // console.log({ data })
      this.currentLab = {
        assets: [data],
        lab,
        isProcessing,
      }
      // Open modal on next DOM update
      Vue.nextTick(() => {
        $('.asset__lab-modal').modal()
        //If coming from asset__modal it will be hidden
        $('.asset__modal').modal('hide')
      })
    },
    // Prepare the selected assets to be opened in lab
    openMultipleLabModal() {
      // console.log('ASSETS ARE', this.selectedAssets)
      const processingAssets = this.selectedAssets.filter((asset) => asset.resource_type.name == 'Datalab')
      console.log({ processingAssets })
      if (processingAssets.length > 1) {
        this.modalTitle = 'Unable to launch'
        this.modalMessage = 'Please select only one Datalab or one or multiple assets.'
        $('.message-modal').modal()
        return
      }
      if (processingAssets.length > 0 && this.selectedAssets.length > 1) {
        // console.log('cant mix processing and non processing assets')
        this.modalTitle = 'Unable to launch'
        this.modalMessage = 'Please select only one Datalab or one or multiple assets.'
        $('.message-modal').modal()
        return
      }
      console.log('did not go out')
      // OPENING SINGLE PROCESSING ASSET
      if (processingAssets.length == 1 && this.selectedAssets.length == 1) {
        // console.log('could launch with only one asset but should call ')
        const lab = this.selectedAssets[0].resource_type.resource_type_labs[0].name
        this.openSingleLabModal(processingAssets[0], lab, true)
        return
      }
      // ELSE
      this.currentLab = {
        assets: this.selectedAssets,
        //  TODO: Remove lab as it is ignored inside AssetLabModal (check)
        lab: 'JupyterLab General', // it is ignored, consider deleting
      }
      //force compute of init name and desc
      this.compute = !this.compute
      // Open modal on next DOM update
      Vue.nextTick(() => {
        $('.asset__lab-modal').modal()
      })
    },
    openSaveFilterModal() {
      //force compute of init name and desc
      this.compute = !this.compute
      $('.assets__save-filter-modal').modal()
    },
    // Make browser download a file from the AJAX response
    async downloadCsv() {
      // searchParams, selectAll, assetIdArray, assets
      const response = await api.downloadCsvAssets(
        this.searchParamsArrayOfObj,
        this.globalSelectAll,
        this.selectedAssetsList
      )
      if (helpers.checkErrMessage(response)) {
        // a message error is received
        this.modalTitle = 'An Error Occurred'
        this.modalMessage = response.error //data
        $('.message-modal').modal()
      } else {
        // Make browser download the response
        const blob = new Blob([response.data], { type: 'text/csv' })
        const a = document.createElement('a')
        a.style.display = 'none'
        const url = window.URL.createObjectURL(blob)
        a.href = url
        // the filename you want
        a.download = 'data.csv'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      }
    },
    // Download multiple assets
    async downloadAssets() {
      const assets = this.selectedAssets.map((asset) => {
        return {
          'asset-id': asset.id,
          'asset-location': asset.path,
        }
      })
      // this.downloadFolder = url.substring(url.lastIndexOf('/') + 1)
      this.modalTitle = 'Download confirmation'
      this.modalMessage = 'Folder will soon be available in the Downloads area... you can safely close this window.'
      this.modalOkText = 'Go to Downloads area'
      this.modalCancelText = 'Close'
      const url = await api.getDownloadUrl(assets, this.searchParamsArrayOfObj, this.globalSelectAll)
      if (helpers.checkErrMessage(url)) {
        // a message error is received
        this.modalTitle = 'An Error Occurred'
        this.modalMessage = url.error // data
        $('.download-message-modal').modal('hide')
        $('.message-modal').modal()
      } else {
        this.downloadFolder = url.substring(url.lastIndexOf('/') + 1)
        this.modalMessage = `Downloading Files...
        Folder ${this.downloadFolder} will be available in the Downloads area.`
        $('.download-message-modal').modal()
      }
    },
    redirectToDownload() {
      this.$router.push({
        name: 'files',
        params: {
          foldername: this.downloadFolder,
        },
      })
    },
    onDayOfYearSelected() {
      // get location of button
      const left = this.$refs.datePicker.getBoundingClientRect().left
      const top = this.$refs.datePicker.getBoundingClientRect().top
      this.datePickerLocation = { top: top + 'px', left: left + 'px' }
      // show the picker button as selected
      this.showPicker = true
      // clear dayFrom dayTo (artificially put to 19800101 both ...)
      this.dateFrom = '1980-01-01'
      this.dateTo = '1980-01-01'
      Vue.nextTick(() => {
        this.dateFrom = null
        this.dateTo = null
      })
      console.log('DATES', this.dateFrom, this.dateTo)
      $('.day-of-year-modal').modal()
      const self = this
      $('.day-of-year-modal').on('hidden.bs.modal', function(e) {
        // show the picker button as unselected
        self.showPicker = false
      })
      let backdrop = document.getElementsByClassName('modal-backdrop')
      backdrop[0].style.opacity = 0
    },
    onDayOfYearChosen(startDate, endDate) {
      $('.day-of-year-modal').modal('hide')
      console.log('PICKER DAY CHOSEN', startDate, endDate)
      this.dateFrom = startDate.format('YYYY-MM-DD HH:mm')
      this.dateTo = endDate.format('YYYY-MM-DD HH:mm')
      this.clearSelection()
      this.syncRoute()
      // show the picker button as unselected
      this.showPicker = false
    },
    DOYCloseModal() {
      $('.day-of-year-modal').modal('hide')
    },
    onGPSWeekSelected() {
      // get location of button
      const left = this.$refs.datePicker.getBoundingClientRect().left
      const top = this.$refs.datePicker.getBoundingClientRect().top
      this.datePickerLocation = { top: top + 'px', left: left + 'px' }
      // show the picker button as selected
      this.showPicker = true
      // clear dayFrom dayTo (artificially put to 19800102 both ...)
      this.dateFrom = '1980-01-02'
      this.dateTo = '1980-01-02'
      Vue.nextTick(() => {
        this.dateFrom = null
        this.dateTo = null
      })
      console.log('DATES', this.dateFrom, this.dateTo)
      $('.gps-week-modal').modal()
      const self = this
      $('.gps-week-modal').on('hidden.bs.modal', function(e) {
        // show the picker button as unselected
        self.showPicker = false
      })
      let backdrop = document.getElementsByClassName('modal-backdrop')
      backdrop[0].style.opacity = 0
    },
    onGPSWeekChosen(startDate, endDate) {
      console.log('gps week chosen')
      $('.gps-week-modal').modal('hide')
      this.dateFrom = startDate.format('YYYY-MM-DD HH:mm')
      this.dateTo = endDate.format('YYYY-MM-DD HH:mm')
      this.clearSelection()
      this.syncRoute()
    },
    onDateRangeChanged(picker) {
      const actuallyOnDateRangeChanged = () => {
        // this.dateRange =
        console.log({ picker })
        this.dateFrom = picker.startDate.format('YYYY-MM-DD HH:mm')
        this.dateTo = picker.endDate.format('YYYY-MM-DD HH:mm')
        // clear selection if there was any
        this.clearSelection()
        this.syncRoute()
      }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallyOnDateRangeChanged, () => {})
      } else {
        actuallyOnDateRangeChanged()
      }
    },
    gpsWeekCloseModal() {
      $('.gps-week-modal').modal('hide')
    },
    showCalendarDay() {
      // open calendar from gpsweek or doy modals
      const datePicker = document.getElementsByClassName('date-icon')
      datePicker[0].click()
    },
    launchLab(id, url) {
      console.log('SHOULD LAUNCH LAB NOW')
      this.$router.push({ name: 'lab', params: { id: id, labUrl: url } })
    },
    searchAutoInputChange() {
      console.log('SEARCHAUTO INPUTCHANGE')
    },
    searchAutoSelected(item) {
      console.log('SEARCHAUTO SELECTED')
      const actuallySearchAutoSelected = () => {
        this.keyword = item ? item.item : this.keyword
        if (this.checkLucene(this.keyword)) {
          // clear selection if there was any
          this.clearSelection()
          this.syncRoute()
        }
      }
      if (this.selectedAssets.length || this.globalSelectAll) {
        this.launchConfirmSelectionLostModal(actuallySearchAutoSelected, () => {})
      } else {
        actuallySearchAutoSelected()
      }
    },
    searchAutoClick() {
      console.log('SEARCHAUTO CLICK')
    },
    searchAutoItemChanged(item) {
      console.log('SEARCHAUTO ITEM CHANGED', item)
      this.itemChanged = item ? item.item : this.keyword
    },
    clsSearchAutoIsKeyword(item) {
      return item == this.itemChanged ? 'bold-me' : ''
    },
    // filterStations(selected) {
    //   console.log('stationssss filterStations', { selected })
    //   this.selectedStations = selected
    //   console.log('stationsss', this.needsSyncRoute)
    //   this.syncRoute()
    //if any filter on stations, remove it

    // search in filters (this.filters) the selected stations
    // const stationFilters = this.filters.filter((filter) => filter.label == 'Station / Platform')[0].children
    // console.log(stationFilters)
    // },
    updateMapStations(mapStations) {
      this.mapStations = mapStations
    },
    launchTooLongRouteMessageModal(oldQuery) {
      this.modalTitle = 'Error'
      this.modalMessage = 'Too many filters selected'
      this.modalOkText = 'Ok'
      // this.cancelCallbackFunction = function() {}
      this.okCallbackFunction = async () => {
        console.log('ROUTE CHANGED IN LAUNCHMODAL', oldQuery)
        await this.$router.push({
          name: 'assets',
          query: oldQuery,
        })
      }
      $('.message-modal').modal()
    },
  },
  async mounted() {
    // default to cards on mobile width (<991px), and hide sidebar
    if (window.innerWidth < 991) {
      this.viewMode = 'grid'
      this.showSidebar = false
      this.pager_max_links = 3
    }
    // sync route query params to UI data
    this.syncSearchParams(false)
    console.log('GET ASSETS - MOUNTED', this.$route)
    await this.getAssets()
    // GET initial valid stations from aggregations
    this.validStations = this.availableStations
    // console.log('VALID STATIONS', this.validStations)
    // Display all sorts by default
    this.userMovedColumns = ['fixedcol'].concat(this.displayedColumns.slice())
    // console.log('usermoved', this.userMovedColumns)
    // if (this.viewMode === 'list') {
    //   //setup table functions
    //   console.log('WPDATA WPDATA WPDATA WPDATA', this.wpData)
    //   const plugin = document.createElement('script')
    //   plugin.setAttribute('src', `${this.wpData.dist + 'js/dragTable.js'}`)
    //   plugin.async = true
    //   document.head.appendChild(plugin)
    // }
    // console.log('selectedColumns', this.selectedColumns)
  },
  destroyed() {
    console.log('destroyed')
    // clear selection of asset when leaving this route
    this.clearSelection()
  },
  watch: {
    displayedColumns: function() {
      console.log('displayed here is', this.displayedColumns)
      console.log('usermoved here is', this.userMovedColumns)
      // Remove from usermoved, all cols that are not in displayed
      this.userMovedColumns = this.userMovedColumns.filter((label) => {
        return this.displayedColumns.includes(label) || label === 'Filename' || label === 'fixedcol'
      })
      console.log('usermoved here is', this.userMovedColumns)
      // Add (at the end) all cols that have been added
      const newCols = this.displayedColumns.filter((label) => !this.userMovedColumns.includes(label))
      console.log({ newCols })
      if (newCols) {
        this.userMovedColumns.splice(2, 0, ...newCols)
      }
    },

    // NOT NEEDED ANYMORE, BETTER TO CALL syncRoute WHEREVER NEEDED IN THE CODE
    // update URL whenever UI search params are modified
    search: {
      deep: true,
      handler: function() {
        console.log('SYNCROUTE FROM SEARCH HANDLER')
        this.syncRoute()
      },
    },

    // unneeded, done in another function, DELETE:
    // // clear Selection when filters change.
    // searchFilters(newVal, oldVal) {
    //   if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
    //     console.log('all filters CHANGED')
    //     this.clearSelection()
    //     // this.modalTitle = 'Selection will be lost'
    //     // this.modalMessage = 'If filters change is applied your current selection will be lost'
    //     // this.modalOkText = 'Confirm filter change'
    //     // this.modalCancelText = 'Keep selection'
    //     // $('.selection-message-modal').modal()
    //   }
    // },

    // Sort mode changed to most-relevant when keyword changes
    // keyword: function() {
    //   this.search.sortOption = 'relevant'
    // },
    // Update autocomplete suggestions when keyword changes
    keyword: async function() {
      const response = await api.getAutocompleteOptions(this.keyword)
      if (this.keyword) {
        if (response) this.autocomplete = response.map((item) => item.word)
      } else {
        this.autocomplete = []
      }
      console.log(this.autocomplete)
    },
    $route: async function(newRoute, oldRoute) {
      this.$refs.autosuggestRef.$refs.searchInputRef.focus()
      console.log('WATCHER', newRoute, oldRoute, this.needsSyncRoute)
      const diff = helpers.getDiffTwoObjects(newRoute.query, oldRoute.query)
      console.log('WATCHER', Object.keys(diff))
      const diffItemsInRoute = Object.keys(diff)
      console.log('WATCHER diff items', diff, diffItemsInRoute)
      // set globalSelectAll to stored value
      this.globalSelectAll = this.storedSelectAll
      // Set selectedAssets to stored value
      this.selectedAssets = this.storedSelection
      // sync route query params to UI data
      this.syncSearchParams()
      // console.log('GET ASSETS - ROUTE CHANGED WATCH COUNT not yet', newRoute.fullPath.length)

      // IF ROUTE > 2000 CHARACTERS DO NOT LOAD ASSETS, RETURN AND LAUNCH MESSAGE MODAL
      // if (newRoute.fullPath.length > 200) {
      //   console.log('GET ASSETS - ROUTE CHANGED WATCH COUNT', newRoute.fullPath.length)
      //   // this.$route = oldRoute
      //   console.log('ROUTE CHANGED', this.routeQuery, oldRoute.query)
      //   this.launchTooLongRouteMessageModal(oldRoute.query)
      //   this.$emit('finishLoading')
      //   return
      // }

      // fetch new data when route changes

      // Default is WITH aggregations
      let withAggregations = true

      // RELOAD ASSETS ONLY IF PREV QUERY WAS NOT EMPTY
      // IF query was empty it is initial load ...
      if (Object.keys(oldRoute.query).length > 0) {
        console.log('WATCHER RELAUNCH ASSETS')
        // if only a page change, do not load aggregations (MUCH FASTER)
        if (diff && diffItemsInRoute) {
          if (
            (diffItemsInRoute.length === 1 && diffItemsInRoute[0] === 'vuePage') ||
            (diffItemsInRoute.length === 1 && diffItemsInRoute[0] === 'size') ||
            (diffItemsInRoute.length === 2 && diffItemsInRoute[0] === 'vuePage' && diffItemsInRoute[1] == 'mode') ||
            (diffItemsInRoute.length === 2 && diffItemsInRoute[0] === 'size' && diffItemsInRoute[1] == 'mode')
          ) {
            console.log('WATCHER - NO AGGREGATIONS')
            withAggregations = false
          }
          if (diffItemsInRoute.length > 0) {
            console.log('WATCHER - GETASSETS WITH AGGREGATIONS: ', withAggregations)
            await this.getAssets(withAggregations)
          } else {
            this.$emit('finishLoading')
          }
        }
        console.log('GET ASSETS - FROM $ROUTE', this.$route)
        // if (withAggregations) {
        //   console.log('antes build asset filters')
        //   this.buildAssetFilters(this.aggregation)
        //   console.log('despues build asset filters')
        // }
      } else {
        // EL LOADER SE ACTIVA CON EL CAMBIO DE ROUTE en App.vue, PERO SI NO HAY QUE RECARGAR
        // HAY QUE DESACTIVAR EL LOADER AQUÍ
        this.$emit('finishLoading')
      }
      // Update assets listed to be marked as selected if they are
      if (!this.globalSelectAll) {
        this.assets.forEach((asset) => {
          if (this.selectedAssets.findIndex((item) => item.id == asset.id) != -1) {
            asset.selected = true
          }
        })
      }

      // if (this.globalSelectAll)
      // If globalSelectAll was true, show selected all items in current page
      if (this.globalSelectAll) {
        this.assets.forEach((asset) => (asset.selected = true))
      }
    },
    // redo get assets, so if user changes its prefs are considered
    user: function() {
      console.log('GET ASSETS - USER CHANGED')
      this.getAssets()
      // console.log('USER CHANGED ')
    },
    selectedAssets: function() {
      this.saveAssetsToStore()
    },
    computedSelectedStations: function(newVal, oldVal) {
      console.log('all selectedStations', newVal, oldVal)
      // remove selection if there was any (if selected stations differ)
      // He necesitado crear una computed prop para que cambie el value
      // Con el this.selectedStations no era suficiente
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        console.log('all selectedstations CHANGED')
        this.clearSelection()
        console.log('syncRoute from computedselectedstations')
        this.search.page = 1
        this.syncRoute('SYNCROUTE COMPUTED SELECTED STATIONS')
      }

      // const filtersToKeep = this.search.filters.filter(
      //   (assetFilter) =>
      //     assetFilter.theField !== 'station_/_platform' ||
      //     (assetFilter.theField === 'station_/_platform' && val.includes(assetFilter.theVal)),
      // )
      // this.search.filters = filtersToKeep
    },
  },
  created() {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // access to component's instance using `vm` . this is done because this navigation guard is called before the component is created.
      console.log('THIS IS BEFORE ROUTE ENTER')

      //vm.initializeSearch();
      next()
    })
  },
}
</script>

<style lang="scss" scoped>
// @import "~@/styles/theme";
@import '~@/styles/globals';
@import '~@/styles/custom';
@import '~bootstrap/scss/mixins';

.assets__search {
  .form-row {
    /* For some weird reason this had a negative margin l & r */
    margin: 0;
  }

  .toggle-sidebar-outside-button {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-top-right-radius: 4px;
    padding-left: 20px;
    padding-right: 5px;
    margin-left: -10px;

    .icon-chevron-left {
      display: inline-block;
      transform: rotate(180deg);
    }

    .icon {
      padding: 0.2rem;
    }
  }

  &-submit {
    background: $primary;
    padding-top: 7px;
    z-index: 100;
    box-shadow: 3px 3px 6px rgb(0 0 0 / 16%);
  }

  &-results {
    position: relative;

    &.loader-on {
      overflow: hidden;
    }

    .loader-wrapper {
      position: static !important;
      height: 100%;
      width: 100%;

      .loader-back {
        opacity: 0.2 !important;
      }

      .main-loader {
        top: 100px !important;
        bottom: unset !important;
      }
    }
  }

  &-results-list {
    overflow-x: scroll;
    // FIXME: Comentado temp, para ver si así la tabla sin scroll propio.
    height: calc(100vh - 336px);

    &::-webkit-scrollbar {
      border-radius: 4px;
      background-color: #f0f0ef;
      -webkit-appearance: none;
      width: 7px;
      height: 7px;
    }

    // Overwrite default safari behavior to show scrollbars always
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.5);
      box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
      -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }

    &::-webkit-scrollbar-corner {
      background: #f0f0ef;
    }
    .table {
      box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.161);
      background-color: white;
    }

    thead {
      white-space: nowrap;

      .custom-control-label {
        padding: 2px;
      }

      /* Enabled */
      .custom-control-input:checked ~ .custom-control-label::before {
        border-color: $main !important;
        background-color: $main !important;
      }

      /* Disabled */
      .custom-control-input:not(:checked) ~ .custom-control-label::after {
        background-color: $main !important;
      }
    }
  }

  &-result-count {
    padding: 7px;
  }

  &-clear-all,
  &-remove-dates,
  &-remove-filter,
  &-remove-coords,
  &-remove-keyword {
    &:hover {
      cursor: pointer;
    }
  }

  &-sort {
    a.dropdown-item {
      color: $deep-space-1;

      &.active {
        color: $deep-space;
        font-weight: bold;
      }
    }
  }

  &-sort-button {
    padding-top: 4px;
  }

  &-search {
    flex: 1 1 1%;
  }

  &-coord {
    flex: 1 1 1%;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 50px;
      top: -7px;
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
      border-bottom: 7px solid #ccc;
    }

    &::after {
      content: '';
      position: absolute;
      left: 51px;
      top: -5px;
      border-right: 6px solid transparent;
      border-bottom: 6px solid #fff;
      border-left: 6px solid transparent;
    }

    &.sidebarClosed {
      &::before {
        left: 120px;
      }

      &::after {
        left: 121px;
      }
    }
  }

  &-box {
    padding: 0 0 0 0;
    z-index: 2;
    border-radius: 0;
    height: 2.25rem;
    div > input.autosuggest__input {
      height: 2.25rem;
    }
  }
}

.assets__sidebar {
  background-color: white;
  border-radius: 0 $border-radius $border-radius 0;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.161);

  .filter-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px -15px;
    padding: 7px 5px 5px 10px;
    border-bottom: 1px solid $neutral-space;

    .title-text {
      margin-left: 4px;
      font-size: 16px;
    }
  }
}

#dropdown-columns.dropdown-toggle,
#dropdown-columns:hover {
  // background-color: white;
  // border: 1px solid #ced4da;
  color: $primary;
  background: #00000007;
}

#app .assets__toggle-map {
  border: 1px solid #ced4da;
  box-shadow: 3px 3px 6px rgb(0 0 0 / 16%);
  background: white;
  display: flex;
  align-items: center;
}

// Añadido para estilo integrado con search bar
// #app .assets__search-clear:not(:hover),
// #app .assets__clear-search:not(:hover) {
//   background-color: white;
//   border: 1px solid #ced4da;
// }
// #app .assets__search-clear:not(:hover) {
//   border-left: none;
// }

.assets__controls {
  margin-bottom: 6px;
  .icon-select {
    padding-left: 0.2rem;
  }

  &-form {
    .form-group {
      select {
        color: $primary;
      }
    }
  }
}

// .date-pickers {
//   flex: auto;
//   width: 1%;
//   .assets__date-from,
//   .assets__date-to {
//     background-color: rgba(0, 0, 0, 0.03);
//   }
// }

@include media-breakpoint-down(md) {
  .assets__search {
    &-show-columns {
      margin-bottom: 0;
    }
  }
}

@include media-breakpoint-down(sm) {
  .assets__search {
    &-size {
      background: transparent;
    }
  }
}

@include media-breakpoint-down(xs) {
  //MOBILE
  .assets__controls {
    &-form {
      //     flex-direction: column-reverse;
      //     align-items: center;
      .form-group {
        display: flex;
        flex: 0 0 auto;
        flex-flow: row wrap;
        align-items: center;
        //       justify-content: space-between;
        //       .assets__search-perpage-label {
        //         padding-left: 7px;
        //         display: flex;
        //         align-items: center;
        //         margin-bottom: 0;
        //       }
        //       select {
        //         width: auto;
        //       }
      }
    }
  }

  .assets__toggle-view {
    display: none;
  }

  //margin to separate from search bar
  .assets__sidebar {
    margin-bottom: 20px;
  }

  //down/up instead of right/left
  .icon-chevron-wrapper-closed,
  .icon-chevron-wrapper-open {
    display: inline-block;
    transform: rotate(90deg);
  }
}

.test-button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10000;
}
</style>
